'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduce2 = _interopRequireDefault(require("lodash/reduce"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EVENTS = ['onClick', 'onDoubleClick', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave'];

function defaultRowRenderer(_ref) {
  var _arguments = arguments;
  var rowData = _ref.rowData,
      index = _ref.index,
      className = _ref.className,
      columns = _ref.columns,
      onClick = _ref.onClick,
      onDoubleClick = _ref.onDoubleClick,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      style = _ref.style;
  var appliedEvents = (0, _reduce2["default"])(EVENTS, function (mapping, event) {
    if (_arguments[0][event]) {
      var callback = function callback(e) {
        return _arguments[0][event]({
          rowData: rowData,
          index: index
        }, e);
      };

      return _objectSpread({}, mapping, _defineProperty({}, event, callback));
    }

    return mapping;
  }, {});
  return _react["default"].createElement("div", _extends({}, appliedEvents, {
    className: className,
    style: style
  }), columns);
}

var _default = defaultRowRenderer;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rapiddot/react-virtual-list/lib/table/default_row_renderer.js
// module id = 136
// module chunks = 0